<script lang="ts" setup>
import { mdiViewDashboardOutline } from "@mdi/js";
import { Icon } from "@soft-db/ui";

const { t } = useI18n();
</script>

<template>
	<div class="hero">
		<div class="hero-content flex-col">
			<Icon class="text-secondary size-16" :d="mdiViewDashboardOutline" />
			<h1 class="text-center" tag="h1" noTruncate>{{ t("dashboard.selectSite") }}</h1>
		</div>
	</div>
</template>
